<template>
    <div class="search-bar">

        <form method="get" :action="formAction">
            <div class="uk-flex uk-flex-left">
                <!-- 히든 검색옵션-->
                <slot name="hiddens"></slot>

                <!-- 검색옵션영역 -->
                <div class="options uk-width-expand">
                    <!-- 기본 검색옵션 -->
                    <div class="default-option">
                        <slot name="default-option"></slot>
                    </div>

                    <!-- 확장 검색옵션 -->
                    <div class="expand-option" v-show="expand">
                        <slot name="expand-option"></slot>
                    </div>

                    <!-- 키워드검색 영역 -->
                    <div class="keyword">
                        <slot name="keyword"></slot>
                    </div>

                </div>

                <div class="uk-flex uk-flex-column">
                    <!-- 검색버튼 -->
                    <button
                        type="submit"
                        class="uk-button search-button btn-style uk-flex-1"
                        :class="searchButtonClass"
                    >
                        <i class="material-icons">search</i>
                        <span>검색</span>
                    </button>

                    <!-- 초기화버튼 -->
                    <button
                        type="button"
                        class="uk-button clear-button btn-style"
                        :class="clearButtonClass"

                        title="검색옵션을 초기화합니다 (전체검색)"

                        @click="clear"
                        @mouseenter="foucsClearButton = true"
                        @mouseleave="foucsClearButton = false"
                    >
                        <i class="material-icons">settings_backup_restore</i>
                        <span>초기화</span>
                    </button>
                </div>

            </div>
        </form>

        <div v-show="hasExpand">
            <!-- 확장 펼치기 버튼 -->
            <div class="expand-open-button btn-style" v-show="! expand" @click="expand = true">
                <i class="material-icons">
                    arrow_drop_down
                </i>
                더 많은 검색옵션

            </div>

            <!-- 확장 닫기 버튼 -->
            <div class="expand-close-button btn-style" v-show="expand" @click="expand = false">
                <i class="material-icons">
                    arrow_drop_up
                </i>
                닫기

            </div>
        </div>


    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 검색 url
             */
            formAction: {
                type: String,
                required: true,
            },

            /**
             * 확장옵션 사용여부
             */
            hasExpand: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                /**
                 * (bool) 확장옵션 영역 표시여부
                 */
                expand: false,

                /**
                 * (bool) 초기화버튼 포커싱(마우스오버)여부
                 */
                foucsClearButton: false,

            };
        },
        computed: {
            searchButtonClass() {
                return {
                    'search-button-focused': ! this.foucsClearButton,
                    'search-button-unfocused': this.foucsClearButton,
                };
            },
            clearButtonClass() {
                return {
                    'clear-button-focused': this.foucsClearButton,
                    'clear-button-unfocused': ! this.foucsClearButton,
                };
            },
        },
        methods: {
            /**
             * 검색옵션 클리어 (전체검색)
             */
            clear() {
                $.app.move(this.formAction);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .search-bar {

        .options {
            background-color: #fff;
            border-left: 1px solid #ddd;
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
            padding: 10px;

            .default-option {

            }
            .expand-option {
            }

            .keyword {
            }

            &:hover {
                background-color: #fff;
                border-left: 1px solid #ccc;
                border-top: 1px solid #ccc;
                border-bottom: 1px solid #ccc;
            }
        }

    }



    .expand-open-button, .expand-close-button {
        padding: 2px;
        text-align: center;
        font-size: 0.875rem;
    }

    .btn-style {
        -moz-box-shadow: inset 0 1px 0 0 #ffffff;
        -webkit-box-shadow: inset 0 1px 0 0 #ffffff;
        box-shadow: inset 0 1px 0 0 #ffffff;
        background: linear-gradient(to bottom, #ffffff 5%, #f6f6f6 100%);
        background-color: #ffffff;
        -moz-border-radius: 6px;
        -webkit-border-radius: 6px;
        border-radius: 6px;
        border: 1px solid #dcdcdc;
        cursor: pointer;
        color: #666666;
        text-decoration: none;
        text-shadow: 0 1px 0 #ffffff;

        &:hover {
            background: linear-gradient(to bottom, #f6f6f6 5%, #ffffff 100%);
            background-color: #f6f6f6;
        }

        &:active {
            position: relative;
            top: 1px;
        }

        // 초기화버튼 스타일
        &.clear-button {
            background: none;
            background-color: #fff;
            border: 1px solid #eee;
            border-radius: 2px;
            box-shadow: none;

            &:hover {
                background-color: #fafafa;
                color: #000;
            }

        }
    }


</style>